export default {
    megatrend: 'Mega-trend',
    macrotrendsOfMegatrend: 'Macro-trends of the same Mega-trend',
    relatedMacrotrends: 'Similar Macro-trends'
}
